// extracted by mini-css-extract-plugin
module.exports = {"authButton":"AuthButton_authButton__S_TLD"};